module.exports = __webpack_public_path__ + "img/thumbnail_Jaguar_m_albino.a5ff5447.png";